import React from "react";
import styled from "styled-components";
import AllAdvertisers from "./Advertisers";
import AllPublishers from "./Publishers";
import { Link } from "react-router-dom";

const CardTab = ({ title, advertisers, publishers }) => {
  // const [activeTab, setActiveTab] = useState("All");

  // const tabs = ["All", "Active", "Inactive", "Top"];
  

  return (
    <Container>
      <div className="header">
        <h2>{title}</h2>
        <Link className="button" to={advertisers ? '/advertisers' : publishers ? '/publishers' : ''}>See more</Link>
      </div>
      {/* <Tabs>
        {tabs.map((tab) => (
          <Tab
            key={tab}
            isActive={activeTab === tab}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </Tab>
        ))}
      </Tabs> */}
      {advertisers && <AllAdvertisers/>}
      {publishers && <AllPublishers/>}

    </Container>
  );
};

export default CardTab;

// Styled Components
const Container = styled.div`
  margin-top: 20px;
  padding: 32px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbff 100%);
  border: 2px solid #e3f2fd;
  border-radius: 16px;
  width: 100%;
  box-shadow: 0 2px 8px rgba(3, 169, 244, 0.08);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(3, 169, 244, 0.12);
  }
  
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 2px solid #e3f2fd;
    
    h2 {
      font-size: 22px;
      font-weight: 600;
      color: #1a237e;
    }
    .button {
      padding: 10px 20px;
      border: 2px solid #03a9f4;
      border-radius: 10px;
      background: transparent;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      color: #03a9f4;
      text-decoration: none;
      transition: all 0.3s ease;
      
      &:hover {
        background-color: #03a9f4;
        color: #ffffff;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(3, 169, 244, 0.3);
      }
    }
  }
`;